export * from './locality.service';
